function stringify(input, level) {
  if (!input) {
    return input
  }

  level = level || 4

  var objectsAlreadySerialized = [input],
    objDepth = [input]

  if (typeof input != 'object') {
    return {}
  }

  return JSON.stringify(input, function (key, value) {
    if (typeof value == 'function') {
      return 'function'
    }
    if (key) {
      if (typeof value === 'object') {
        if (objectsAlreadySerialized.indexOf(value) !== -1) return undefined

        objectsAlreadySerialized.push(value)
      }

      if (objDepth.indexOf(this) === -1) objDepth.push(this)
      else while (objDepth[objDepth.length - 1] !== this) objDepth.pop()

      if (objDepth.length > level) return undefined
    }

    return value
  })
}

export function bt_navback() {
  window.history.back()
}

export function FramePostMsg(
  pAction,
  pRetval,
  pUserData,
  pSrc,
  pParmMap = undefined,
  pOrigin = undefined,
  pParent = undefined
) {
  var inframe = false
  var origin = window
  if (pOrigin) {
    origin = pOrigin
  }
  if (!pUserData || pUserData == '') {
    pUserData = {}
  }

  var dialogparent = stringify(origin.dialogparent, 1) ?? null
  if (pParent) {
    dialogparent = stringify(pParent, 1) ?? null
  }

  try {
    dialogparent = JSON.parse(dialogparent)
  } catch (e) {
    console.log('FramePostMsg:Error:', e, dialogparent)
  }
  // var dialogparent = origin.dialogparent ?? null
  // if (pParent) {
  //   dialogparent = pParent
  // }

  var msg = {
    Parent: 1,
    Action: pAction,
    ResultCode: pRetval,
    UserData: JSON.parse(JSON.stringify(pUserData)),
    Src: pSrc,
    DialogParent: {
      type: stringify(origin.dialogparenttype, 1) ?? '',
      dialogparent: dialogparent,
    },
  }

  if (typeof pParmMap == 'object') {
    msg = Object.assign(msg, pParmMap)
  }

  var evt = new CustomEvent('framepostmsg', { detail: msg })
  origin.dispatchEvent(evt)

  if (origin.frameElement) {
    msg['IFrameID'] = origin.frameElement.getAttribute('id')
    msg['DialogID'] = origin.frameElement.getAttribute('dialogid')
    inframe = true
  } else {
    //msg["DialogParent"] = null;
  }

  if (origin !== origin.parent) {
    origin.parent.postMessage(msg)
    var frmCnt = origin.parent.frames.length
    //console.log("Frame msg posts M1",msg["DialogID"], origin.location, origin.title, origin.frames.length);
    //console.log("Frame msg posts P1", origin.parent.location, origin.parent.title, frmCnt);
    //console.log("Frame msg posts P2", origin.parent.parent.location, origin.parent.parent.title, origin.parent.parent.frames.length);
    for (let i = 0; i < frmCnt; i++) {
      if (origin.parent.frames[i] === origin.parent) {
        continue
      }
      if (origin.parent.frames[i] === origin) {
        continue
      }
      origin.parent.frames[i].postMessage(msg)
      //console.log("Posted msg", msg["DialogID"], origin.parent.frames[i].location, origin.parent.frames[i].title,  origin.parent.frames[i].frames.length);

      let innerframe = origin.parent.frames[i]
      let fCnt = innerframe.frames.length
      for (let i2 = 0; i2 < fCnt; i2++) {
        if (innerframe.frames[i2] === innerframe.parent) {
          continue
        }
        if (innerframe.frames[i2] === innerframe) {
          continue
        }
        if (innerframe.frames[i2] === origin.parent) {
          continue
        }
        if (innerframe.frames[i2] === origin) {
          continue
        }
        innerframe.frames[i2].postMessage(msg)
        //console.log("Posted msg imd", msg["DialogID"], innerframe.frames[i2].location, innerframe.frames[i2].title,  innerframe.frames[i2].frames.length);
      }
    }
  } else if (pOrigin) {
    pOrigin.postMessage(msg)
    //console.log("Frame msg posts 2",msg["DialogID"], origin.location, origin.frames);
  }

  return inframe
}

export function cla_event(
  procedurename,
  request = '',
  tableprefix = '',
  rid = 0,
  uid = 0,
  parms = {},
  callback = undefined
) {
  uid = 0
  if (typeof parms == 'object') {
    parms = JSON.stringify(parms)
  }

  if (!parms) {
    parms = ''
  }

  //Delay a little for mouse lock issue.
  if (typeof parms == 'string' && parms.indexOf('.htm') > 0) {
    //Hijack event for help links
    console.log(
      `CLA:HELP|${procedurename}|${request}|${tableprefix}|${rid}|${uid}|${parms}|common|${callback}`
    )
  } else {
    console.log(
      `CLA:Event|${procedurename}|${request}|${tableprefix}|${rid}|${uid}|${parms}|common|${callback}`
    )
  }
}
